import { PlusIcon, XMarkIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import { FC, useState } from 'react';

const MultiSelect: FC<{
  onChange?: (data: any) => void;
  prevData: any;
  readOnly?: boolean;
  options?: {
    label: string;
    value: string;
    color?: string;
  }[];
  displaySmall?: boolean;
}> = ({ onChange, readOnly, prevData, options, displaySmall }) => {
  const [selectedOptions, setSelectedOptions] = useState(prevData);

  const removeOption = (value: string) => {
    if (readOnly) return;
    setSelectedOptions(prev => prev.filter(option => option !== value));
    if (onChange) onChange(selectedOptions.filter(option => option !== value));
  };

  const addOption = (value: string) => {
    if (readOnly) return;
    setSelectedOptions(prev => [...prev, value]);
    if (onChange) onChange([...selectedOptions, value]);
  };

  return (
    <>
      {selectedOptions.length > 0 && (
        <div className="flex flex-row flex-wrap gap-2 py-2">
          {selectedOptions.map(selectedOption => (
            <span
              className={classNames(
                'inline-flex items-center gap-1 rounded-full bg-indigo-50 font-medium text-indigo-700 transition-colors',
                displaySmall ? 'py-0.5 pl-3 pr-1.5 text-xs' : 'py-1 pl-3.5 pr-2 text-sm',
                !readOnly && 'hover:bg-indigo-100'
              )}
              key={selectedOption}
            >
              {options?.find(option => option.value === selectedOption)?.label}
              {!readOnly && (
                <button
                  type="button"
                  aria-label="Remove"
                  className="rounded-full p-0.5 text-indigo-400 transition-colors hover:bg-indigo-200/60 hover:text-indigo-700"
                  onClick={() => removeOption(selectedOption)}
                >
                  <XMarkIcon className="h-3.5 w-3.5" />
                </button>
              )}
            </span>
          ))}
        </div>
      )}
      {!readOnly && (
        <div className="grid grid-flow-row grid-cols-3 gap-2 rounded-xl border border-gray-200 bg-gray-50/50 p-4">
          {options
            ?.filter(option => !selectedOptions.includes(option.value))
            .map(option => (
              <button
                type="button"
                title={option.label}
                className="group inline-flex h-10 min-w-0 items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 text-center text-sm font-medium text-gray-700 transition-colors hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-700"
                key={option.value}
                onClick={() => addOption(option.value)}
              >
                <PlusIcon className="h-4 w-4 flex-shrink-0 text-gray-400 transition-colors group-hover:text-indigo-500" />
                <span className="text-xs">{option.label}</span>
              </button>
            ))}
        </div>
      )}
    </>
  );
};

export default MultiSelect;
